import { render, staticRenderFns } from "./ProductCardWrapper.vue?vue&type=template&id=bc03c986&lang=pug&"
import script from "./ProductCardWrapper.vue?vue&type=script&lang=js&"
export * from "./ProductCardWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports